import { Config } from './Config';
import '../App.css';
import Cookies from 'js-cookie';
// import {  } from 'react';
import { useTranslation } from "react-i18next";

export async function FetchAsync(url, post) {

    let lang = Cookies.get('i18next');
    // if (!post) {
    //     post = {};
    // }
    post.lang = lang;
    
    const requestOptions = {
        method: 'POST',
        credentials : "include",
        signal: AbortSignal.timeout(30000),
        headers: {  
            'Content-Type': 'application/json', 
            'language': lang,
        },
        body: JSON.stringify(post)
    };

    try {

        const res = await fetch(Config.domain+url, requestOptions);

        if (res.status != 200) {

            if(res.status === 400){
                return res;
            } else if(res.status === 401){ 
                return {error: "login"};
                // window.location = "/login";
            } else if(res.status === 404){ 
                return {error: "not found"};
            } else {
                return {error: res};
            }

        } else {

            const data = await res?.json();

            if (data.error) {
                return {error: data.error};
            } else {

                return data;
                
            }
        }
    } catch(e) {
        console.log(e);
        return {error: "error"};
    }

}

export default async function Fetch(url, _callback, post) {

    let lang = Cookies.get('i18next');
    post.lang = lang;

    const requestOptions = {
        method: 'POST',
        credentials : "include",
        signal: AbortSignal.timeout(30000),
        headers: {  
            'Content-Type': 'application/json', 
            'language': lang,
        },
        body: JSON.stringify(post)
    };
    

    try {
        const res = await fetch(Config.domain+url, requestOptions);
        if (res.status != 200) {
            
            if(res.status === 400){
                _callback({error: "no data"});
            } else if(res.status === 401){ 
                // window.location = "/login";
                _callback({error: "login"});
            } else if(res.status === 404){ 
                _callback({error: "not found"});
            } else {
                
                _callback({error: res});
            }

        } else {

            const data = await res?.json();
            if (data.error) {
                _callback({error: data.error});
            } else {
                if (typeof _callback == 'function'){
                    _callback(data);
                }
            }
        }
    } catch(e) {
        console.log(e);
        _callback({error: "error"});
    }
}

export async function GET(url) {

    let lang = Cookies.get('i18next');
    const requestOptions = {

        method: 'GET',
        credentials : "include",
        signal: AbortSignal.timeout(30000),
        headers: {  
            'Content-Type': 'application/json', 
            'language': lang,
        }

    };

    let res;
    try {
        res = await fetch(Config.domain+url, requestOptions);
    } catch(e) {
        return { error: e }
    }
    
    
    if (res.status != 200) {
        console.log(res.status);
        if(res.status === 400){
            return {error: "no data"};
        } else if(res.status === 401){ 
            // window.location = "/login";
            return {error: "login"};
        } else if(res.status === 404){ 
            return {error: "not found"};
        } else {
            
            return {error: res};
        }

    } else {

        const data = await res?.json();
        if (data.error) {
            return {error: data.error};
        } else {

            return data;
            
        }
    }

}

export function Loader({styles}) { 
    return (
        <div style={styles} className='LoaderBox'>
            <span className="loader"></span>
        </div>
    );
}

export function IsJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return JSON.parse(str);
}


export async function UploadFile(file) { 

    async function upload(base) { 

        var reader = new FileReader();

        return new Promise(resolve => {
            reader.onload = ev => {
              resolve(reader.result)
            }
            reader.readAsDataURL(base)
        })
    }

    let arr = [];

    if (file.target.files?.length) {

        await Promise.all(
            Array.from(file.target.files)?.map(async (v, k) => {

                let splitFormatsAllowed = Config?.formatAllowed?.split(",");
                let ck = splitFormatsAllowed?.filter(r => r == v?.type);
                if (ck?.length) {
                    let r = await upload(v);
                    arr.push(r);
                } else {
                    arr = { error: "Image format is not allowed!!" };
                }
            })
        )

    }

    return arr;

    
}

export function Image({src, style}) {
    if (!src) {
        return (
            <img src="/Files/nopic.jpg" style={style} />
        );
    } else {
        return (
            <img src={src} style={style} />
        );
    }
    
}

export function NumberFormat({num}) {

    if (num >= 1000 && num < 1000000) {
        num = (num / 1000).toFixed(1) + "K";
    } else if (num > 1000000) {
        num = (num / 1000000).toFixed(1) + "M";;
    } 

    return <>{num}</>
}

export function DateToText({time, type}) {

    const { t } = useTranslation();
    const now = Date.now();

    let timer = (now - time);
    let diff = parseInt(timer / 60 / 1000);   
    if (isNaN(diff)) {
        timer = (now - new Date(time).getTime());
        diff = parseInt(timer / 60 / 1000);
    }

    let formattedDate;

    if (type == "date") {
        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit'});
        return formattedDate;
    } else if (type == "datetime") {

        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });
    
        return formattedDate;
    }
    
    if (diff < 0) {

        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });
    
    } else {
        
        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });

        if (diff < 1) {
            formattedDate = t("now");
        } else if (diff < 60 && diff >= 1) {
            formattedDate = `${t("before")} ${diff} ${t("minutes")}`;
        } else if (diff >= 60 && diff < 1440) {
            formattedDate = `${t("before")} ${parseInt(timer / 60 / 60 / 1000)} ${t("hours")}`;
        }

        // console.log(diff);
    }

    return (
        <>{formattedDate}</>
    );

}


export function SecoundsToTime({time}) {
    if (!time) {
        time = 0;
    }


    var date = new Date(time);
    date.setSeconds(time);
    var timeString = date.toISOString().substring(11, 19);
    return timeString;
}

export function dateToText(time, type) {
    

    const now = Date.now();

    let timer = (now - time);
    let diff = parseInt(timer / 60 / 1000);   
    if (isNaN(diff)) {
        timer = (now - new Date(time).getTime());
        diff = parseInt(timer / 60 / 1000);
    }

    let formattedDate;

    if (type == "date") {
        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit'});
        return formattedDate;
    } else if (type == "datetime") {

        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });
    
        return formattedDate;
    }
    
    if (diff < 0) {

        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });
    
    } else {
        
        const date = new Date(time);
        formattedDate = date.toLocaleDateString('he-IL', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false, hour: "2-digit", minute: "2-digit" });

        if (diff < 1) {
            formattedDate = "Now";
        } else if (diff < 60 && diff >= 1) {
            formattedDate = `${diff} Minutes ago`;
        } else if (diff >= 60 && diff < 1440) {
            formattedDate = `${parseInt(timer / 60 / 60 / 1000)} Hours ago`;
        }

        // console.log(diff);
    }
    
    

    return formattedDate;
}

export function PlaySound(text) {
    const synth = window.speechSynthesis;
    const u = new SpeechSynthesisUtterance(text);
    // u.voice = synth.getVoices()[1];
    u.rate = 0.8;
    synth.speak(u);
}

export function ClassToName({classes, string}) {
    
    if (!classes) {
        return false;
    }
    let cl = classes?.split("-");
    
    if (string) {
        return `${global?.Classes[cl[0]]} ${global?.Grades[cl[1]]}`;
    } else {
        return <>{global?.Classes[cl[0]]} {global?.Grades[cl[1]]}</>
    }
}

export function permissions( userinfo, data, cat, type) {

    if (userinfo?.userlevel >= 6) {
        return true;
    }
    
    // console.log(userinfo?.school?.perms, cat); 
    
    let perms = {};
    if (cat) {
        let perms = userinfo?.school?.perms?.filter(d => d?.ck == type && d?.cat == cat);
        perms = perms?.length ? perms[0] : false;
    } else {
        let perms = userinfo?.school?.perms?.filter(d => d?.ck == type);
        perms = perms?.length ? perms[0] : false;
    }

    let allow = false;
    if (perms) {
        if (!perms?.sub?.length) {
            allow = true;
        } else {
            
            if (!data) {
                allow = true;
            } else {
                let ck = perms?.sub?.filter(r => r == data );
                if (ck?.length) {
                    allow = true;
                }
            }
        }
    }

    return allow;
}